import { render } from "./notificationMessage.vue?vue&type=template&id=0ee9c908&scoped=true"
import script from "./notificationMessage.vue?vue&type=script&lang=js"
export * from "./notificationMessage.vue?vue&type=script&lang=js"

import "./notificationMessage.vue?vue&type=style&index=0&id=0ee9c908&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee9c908"]])

export default __exports__